import store from '../store/index'

/**
 * Basic Routes
 * */
const Login = () => import('~/pages/auth/login').then(m => m.default || m)
const Register = () => import('~/pages/auth/register').then(m => m.default || m)
const PasswordEmail = () => import('~/pages/auth/password/email').then(m => m.default || m)
const PasswordReset = () => import('~/pages/auth/password/reset').then(m => m.default || m)
const NotFound = () => import('~/pages/errors/404').then(m => m.default || m)

/**
 * Part Number Routes
 * */
const Product = () => import('~/pages/product/index').then(m => m.default || m)
const ProductList = () => import('~/pages/product/list').then(m => m.default || m)
const ProductView = () => import('~/pages/product/view').then(m => m.default || m)
const ProductNew = () => import('~/pages/product/form').then(m => m.default || m)
const ProductEdit = () => import('~/pages/product/form').then(m => m.default || m)

/**
 * Paint Master Routes
 * */
const Paint = () => import('~/pages/paint/index').then(m => m.default || m)
const PaintList = () => import('~/pages/paint/list').then(m => m.default || m)
const PaintView = () => import('~/pages/paint/view').then(m => m.default || m)
const PaintNew = () => import('~/pages/paint/form').then(m => m.default || m)
const PaintEdit = () => import('~/pages/paint/form').then(m => m.default || m)

/**
 * Inventory Utilities Routes
 */
const IU = () => import('~/pages/inventory/utilities/index').then(m => m.default || m)
const IUStatus = () => import('~/pages/inventory/utilities/inventoryStatus').then(m => m.default || m)
const IUTransaction = () => import('~/pages/inventory/utilities/transactionHistory').then(m => m.default || m)
const IUShipped = () => import('~/pages/inventory/utilities/shippedSoByPn').then(m => m.default || m)
const IUReceived = () => import('~/pages/inventory/utilities/receivedPoByPn').then(m => m.default || m)

/**
 * BOM Master Routes
 * */
const BOM = () => import('~/pages/bom/index').then(m => m.default || m)
const BOMList = () => import('~/pages/bom/list').then(m => m.default || m)

/**
 * Estimate Routes
 */
const Estimate = () => import('~/pages/csg/estimate/index').then(m => m.default || m)
const EstimateList = () => import('~/pages/csg/estimate/list').then(m => m.default || m)
const EstimateEdit = () => import('~/pages/csg/estimate/form').then(m => m.default || m)

/**
 * Estimate Routes
 */
const Blanket = () => import('~/pages/csg/blanket/index').then(m => m.default || m)
const BlanketList = () => import('~/pages/csg/blanket/list').then(m => m.default || m)
const BlanketEdit = () => import('~/pages/csg/blanket/form').then(m => m.default || m)

/**
 * Voucher Routes
 */
const Voucher = () => import('~/pages/accounting/voucher/index').then(m => m.default || m)
const VoucherList = () => import('~/pages/accounting/voucher/list').then(m => m.default || m)
const VoucherEdit = () => import('~/pages/accounting/voucher/form').then(m => m.default || m)

/**
 * Vendor Return Routes
 */
const VendorReturn = () => import('~/pages/purchasing/vendor_return/index').then(m => m.default || m)
const VendorReturnList = () => import('~/pages/purchasing/vendor_return/list').then(m => m.default || m)
const VendorReturnEdit = () => import('~/pages/purchasing/vendor_return/form').then(m => m.default || m)

/**
 * RGA Routes
 */
const RGA = () => import('~/pages/csg/rga/index').then(m => m.default || m)
const RGAList = () => import('~/pages/csg/rga/list').then(m => m.default || m)
const RGAEdit = () => import('~/pages/csg/rga/form').then(m => m.default || m)

/**
 * Customer owned Rga Routes
 */
const CORGA = () => import('~/pages/csg/customer_owned_rga/index').then(m => m.default)
const CORGAList = () => import('~/pages/csg/customer_owned_rga/list').then(m => m.default)
const CORGAEdit = () => import('~/pages/csg/customer_owned_rga/form').then(m => m.default)

/**
 * Invoice Routes
 */
const Invoice = () => import('~/pages/accounting/invoice/index').then(m => m.default || m)
const InvoiceList = () => import('~/pages/accounting/invoice/list').then(m => m.default || m)
const InvoiceEdit = () => import('~/pages/accounting/invoice/form').then(m => m.default)

/**
 * Commissions Sales Rep Routes
 */
const Commissions = () => import('~/pages/commissions/commissions/index').then(m => m.default || m)
const CommissionsList = () => import('~/pages/commissions/commissions/list').then(m => m.default || m)
const CommissionsEdit = () => import('~/pages/commissions/commissions/form').then(m => m.default || m)
/**
 * Commissions Sales Rep Routes
 */
const CommissionsSalesRep = () => import('~/pages/commissions/sales-rep/index').then(m => m.default || m)
const CommissionsSalesRepList = () => import('~/pages/commissions/sales-rep/list').then(m => m.default || m)
const CommissionsSalesRepEdit = () => import('~/pages/commissions/sales-rep/form').then(m => m.default)

/**
 * Commissions Voucher Routes
 */
const CommissionsVoucher = () => import('~/pages/commissions/voucher/index').then(m => m.default || m)
const CommissionsVoucherList = () => import('~/pages/commissions/voucher/list').then(m => m.default || m)
const CommissionsVoucherEdit = () => import('~/pages/commissions/voucher/form').then(m => m.default || m)

/**
 * Commissions Rate Routes
 */
const CommissionsRate = () => import('~/pages/commissions/rate/index').then(m => m.default || m)
const CommissionsRateList = () => import('~/pages/commissions/rate/list').then(m => m.default || m)

/**
 * Business Partners Routes
 * */
const BP = () => import('~/pages/csg/partners/index').then(m => m.default || m)
const BPList = () => import('~/pages/csg/partners/list').then(m => m.default || m)
const BPView = () => import('~/pages/csg/partners/view').then(m => m.default || m)
const BPEdit = () => import('~/pages/csg/partners/form').then(m => m.default || m)
const BPNew = () => import('~/pages/csg/partners/form').then(m => m.default || m)

/**
 * Business Partners Routes
 * */
const SO = () => import('~/pages/csg/sales_order/index').then(m => m.default || m)
const SOList = () => import('~/pages/csg/sales_order/list').then(m => m.default || m)
const SOView = () => import('~/pages/csg/sales_order/view').then(m => m.default || m)
const SOEdit = () => import('~/pages/csg/sales_order/form').then(m => m.default || m)
const SONew = () => import('~/pages/csg/sales_order/form').then(m => m.default || m)

/**
 * Selling price Routes
 * */
const SP = () => import('~/pages/csg/selling_price/index').then(m => m.default || m)
const SPList = () => import('~/pages/csg/selling_price/list').then(m => m.default || m)

/**
 * Admin Panel Routes
 */
const AP = () => import('~/pages/system/admin-panel/index').then(m => m.default || m)
const APList = () => import('~/pages/system/admin-panel/list').then(m => m.default || m)
const APView = () => import('~/pages/system/admin-panel/view').then(m => m.default || m)
const APNew = () => import('~/pages/system/admin-panel/form').then(m => m.default || m)

/**
 * Purchase Order Routes
 */
const PO = () => import('~/pages/purchasing/purchase_order/index').then(m => m.default || m)
const POList = () => import('~/pages/purchasing/purchase_order/list').then(m => m.default || m)
const POView = () => import('~/pages/purchasing/purchase_order/view').then(m => m.default || m)
const POEdit = () => import('~/pages/purchasing/purchase_order/form').then(m => m.default || m)

/**
 * Purchase Price Routes
 */
const PP = () => import('~/pages/purchasing/purchase_price/index').then(m => m.default || m)
const PPList = () => import('~/pages/purchasing/purchase_price/list').then(m => m.default || m)

const PermissionAlert = () => import('~/components/PermissionAlert').then(m => m.default || m)

/**
 * Packing Slip Routes
 */
const PS = () => import('~/pages/inventory/packing-slip/index').then(m => m.default || m)
const PSList = () => import('~/pages/inventory/packing-slip/list').then(m => m.default || m)
const PSEdit = () => import('~/pages/inventory/packing-slip/form').then(m => m.default || m)

/**
 * MRP Routes
 */
const MRP = () => import('~/pages/production-control/mrp/index').then(m => m.default || m)
const MRPList = () => import('~/pages/production-control/mrp/list').then(m => m.default || m)

/**
 * Inventory Receipt Routes
 */
const IR = () => import('~/pages/inventory/receipt/index').then(m => m.default || m)
const IRList = () => import('~/pages/inventory/receipt/list').then(m => m.default || m)
const IREdit = () => import('~/pages/inventory/receipt/form').then(m => m.default || m)

/**
 * Inventory Receipt Routes
 */
const IC = () => import('~/pages/inventory/count/index').then(m => m.default || m)
const ICList = () => import('~/pages/inventory/count/list').then(m => m.default || m)

/**
 * Inventory Cycle Count Routes
 */
const ICC = () => import('~/pages/inventory/cycle-count/index').then(m => m.default || m)
const ICCList = () => import('~/pages/inventory/cycle-count/list').then(m => m.default || m)

/**
 * Inventory Transfer Routes
 */
const IT = () => import('~/pages/transfer/index').then(m => m.default || m)
const ITList = () => import('~/pages/transfer/list').then(m => m.default || m)

const Home = () => import('~/pages/default').then(m => m.default || m)

/**  * Adjust Inventory Routes  */
const AI = () => import('~/pages/adjust/index').then(m => m.default || m)
const AIList = () => import('~/pages/adjust/list').then(m => m.default || m)

/**  * Detailing Routes  */
const Detailing = () => import('~/pages/detailing/index').then(m => m.default || m)
const DetailingList = () => import('~/pages/detailing/list').then(m => m.default || m)
const DetailingEdit = () => import('~/pages/detailing/form').then(m => m.default || m)

/**  * Work Order Routes  */
const WO = () => import('~/pages/production-control/work-order/index').then(m => m.default || m)
const WOList = () => import('~/pages/production-control/work-order/list').then(m => m.default || m)
const WOScheduling = () => import('~/pages/production-control/work-order/scheduling').then(m => m.default || m)
const WOEdit = () => import('~/pages/production-control/work-order/form').then(m => m.default || m)
const WOAutoEdit = () => import('~/pages/production-control/work-order/auto-form').then(m => m.default || m)

/**  * Close Work Order  */
const CWO = () => import('~/pages/production-control/close-work-order/index').then(m => m.default || m)
const CWOList = () => import('~/pages/production-control/close-work-order/list').then(m => m.default || m)

/**  * Production Matrix Routes  */
const PM = () => import('~/pages/production-matrix/index').then(m => m.default || m)
const PMList = () => import('~/pages/production-matrix/list').then(m => m.default || m)

/**  * Reports Module Routes  */

const Reports = () => import('~/pages/reports/index').then(m => m.default || m)
const PDMReports = () => import('~/pages/reports/PDMReports').then(m => m.default || m)
const ProductionControlReports = () => import('~/pages/reports/ProductionControlReports').then(m => m.default || m)
const InventoryReports = () => import('~/pages/reports/InventoryReports').then(m => m.default || m)
const CSGReports = () => import('~/pages/reports/CSGReports').then(m => m.default || m)
const PurchasingReports = () => import('~/pages/reports/PurchasingReports').then(m => m.default || m)
const AccountingReports = () => import('~/pages/reports/AccountingReports').then(m => m.default || m)
const MiscellaneousReports = () => import('~/pages/reports/MiscellaneousReports').then(m => m.default || m)

export default [
  { path: '/', name: 'home', component: Home },

  { path: '/login', name: 'login', component: Login },
  { path: '/register', name: 'register', component: Register },
  { path: '/password/reset', name: 'password.request', component: PasswordEmail },
  { path: '/password/reset/:token', name: 'password.reset', component: PasswordReset },

  {
    path: '/:companyId/product',
    component: Product,
    children: [
      { path: '', redirect: { name: 'product.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'product.list', component: ProductList },
      { path: 'view/:productId', name: 'product.view', component: ProductView },
      { path: 'new', name: 'product.new', component: ProductNew },
      { path: 'edit/:productId', name: 'product.edit', component: ProductEdit }
    ]
  },

  {
    path: '/:companyId/paint',
    component: Paint,
    children: [
      { path: '', redirect: { name: 'paint.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'paint.list', component: PaintList },
      { path: 'view/:paintId', name: 'paint.view', component: PaintView },
      { path: 'new', name: 'paint.new', component: PaintNew },
      { path: 'edit/:paintId', name: 'paint.edit', component: PaintEdit }
    ]
  },

  {
    path: '/:companyId/bom',
    component: BOM,
    children: [
      { path: '', redirect: { name: 'bom.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'bom.list', component: BOMList }
    ]
  },

  {
    path: '/:companyId/estimates',
    component: Estimate,
    children: [
      { path: '', redirect: { name: 'estimates.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'estimates.list', component: EstimateList },
      { path: 'edit/:id', name: 'estimate.edit', component: EstimateEdit }
    ]
  },
  {
    path: '/:companyId/blanket',
    component: Blanket,
    children: [
      { path: '', redirect: { name: 'blanket.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'blanket.list', component: BlanketList },
      { path: 'edit/:id', name: 'blanket.edit', component: BlanketEdit }
    ]
  },

  {
    path: '/:companyId/vouchers',
    component: Voucher,
    children: [
      { path: '', redirect: { name: 'vouchers.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'vouchers.list', component: VoucherList },
      { path: 'edit/:id', name: 'voucher.edit', component: VoucherEdit, props: { type: 'edit' } },
      { path: 'create/:id', name: 'voucher.create', component: VoucherEdit, props: { type: 'create' } }
    ]
  },

  {
    path: '/:companyId/invoices',
    component: Invoice,
    children: [
      { path: '', redirect: { name: 'invoices.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'invoices.list', component: InvoiceList },
      { path: 'edit/:id', name: 'invoice.edit', component: InvoiceEdit }
    ]
  },

  {
    path: '/:companyId/commissions/voucher',
    component: CommissionsVoucher,
    children: [
      { path: '', redirect: { name: 'commissions.voucher.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'commissions.voucher.list', component: CommissionsVoucherList },
      { path: 'edit/:id', name: 'commissions.voucher.edit', component: CommissionsVoucherEdit }
    ]
  },

  {
    path: '/:companyId/commissions/sales-rep',
    component: CommissionsSalesRep,
    children: [
      { path: '', redirect: { name: 'commissions.sales_rep.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'commissions.sales_rep.list', component: CommissionsSalesRepList },
      { path: 'edit/:id', name: 'commissions.sales_rep.edit', component: CommissionsSalesRepEdit }
    ]
  },
  {
    path: '/:companyId/commissions/rate',
    component: CommissionsRate,
    children: [
      { path: '', redirect: { name: 'commissions.rate.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'commissions.rate.list', component: CommissionsRateList }
    ]
  },
  {
    path: '/:companyId/commissions',
    component: Commissions,
    children: [
      { path: '', redirect: { name: 'commissions.commissions.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'commissions.commissions.list', component: CommissionsList },
      { path: 'edit/:id', name: 'commissions.commissions.edit', component: CommissionsEdit }
    ]
  },
  {
    path: '/:companyId/mrp',
    component: MRP,
    children: [
      { path: '', redirect: { name: 'mrp.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'mrp.list', component: MRPList }
    ]
  },

  {
    path: '/:companyId/partners',
    component: BP,
    children: [
      { path: '', redirect: { name: 'partners.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'partners.list', component: BPList },
      { path: 'edit/:id', name: 'partners.edit', component: BPEdit },
      { path: 'new', name: 'partners.new', component: BPNew },
      { path: 'view/:id', name: 'partners.view', component: BPView }
    ]
  },

  {
    path: '/:companyId/receipt',
    component: IR,
    children: [
      { path: '', redirect: { name: 'receipt.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'receipt.list', component: IRList },
      { path: 'edit/:id', name: 'receipt.edit', component: IREdit }
    ]
  },

  {
    path: '/:companyId/inventory/count',
    component: IC,
    children: [
      { path: '', redirect: { name: 'inventory.count.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'inventory.count.list', component: ICList }
    ]
  },

  {
    path: '/:companyId/inventory/cycle-count',
    component: ICC,
    children: [
      { path: '', redirect: { name: 'inventory.cycle.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'inventory.cycle.list', component: ICCList }
    ]
  },

  {
    path: '/:companyId/utilities',
    component: IU,
    children: [
      { path: '', redirect: { name: 'utilities.status', params: { companyId: store.getters['auth/company'] } } },
      { path: 'status', name: 'utilities.status', component: IUStatus },
      { path: 'transaction', name: 'utilities.transaction', component: IUTransaction },
      { path: 'shipped', name: 'utilities.shipped', component: IUShipped },
      { path: 'received', name: 'utilities.received', component: IUReceived }
    ]
  },

  {
    path: '/:companyId/app-users',
    component: AP,
    children: [
      { path: '', redirect: { name: 'system.admin.users.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'system.admin.users.list', component: APList },
      { path: 'view/:id', name: 'system.admin.users.view', component: APView },
      { path: 'new', name: 'system.admin.users.new', component: APNew }
    ]
  },

  {
    path: '/:companyId/sales_orders',
    component: SO,
    children: [
      { path: '', redirect: { name: 'so.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'so.list', component: SOList },
      { path: 'edit/:id', name: 'so.edit', component: SOEdit },
      { path: 'new', name: 'so.new', component: SONew },
      { path: 'view/:id', name: 'so.view', component: SOView }
    ]
  },
  {
    path: '/:companyId/selling_price',
    component: SP,
    children: [
      { path: '', redirect: { name: 'sp.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'sp.list', component: SPList }
    ]
  },

  {
    path: '/:companyId/purchase_order',
    component: PO,
    children: [
      { path: '', redirect: { name: 'purchase.order.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'purchase.order.list', component: POList },
      { path: 'edit/:id', name: 'purchase.order.edit', component: POEdit },
      { path: 'view/:id', name: 'purchase.order.view', component: POView }
    ]
  },

  {
    path: '/:companyId/purchase_price',
    component: PP,
    children: [
      { path: '', redirect: { name: 'purchase.price.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'purchase.price.list', component: PPList }
    ]
  },

  {
    path: '/:companyId/inventory_transfer',
    component: IT,
    children: [
      { path: '', redirect: { name: 'transfer.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'transfer.list', component: ITList }
    ]
  },

  {
    path: '/permission-denied',
    name: 'permission-alert',
    component: PermissionAlert
  },

  {
    path: '/:companyId/adjust_inventory',
    component: AI,
    children: [
      { path: '', redirect: { name: 'adjustment.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'adjustment.list', component: AIList }
    ]
  },

  {
    path: '/:companyId/packing-slip',
    component: PS,
    children: [
      { path: '', redirect: { name: 'packing-slip.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'packing-slip.list', component: PSList },
      { path: 'edit/:id', name: 'packing-slip.edit', component: PSEdit }
    ]
  },

  {
    path: '/:companyId/detailing',
    component: Detailing,
    children: [
      { path: '', redirect: { name: 'detailing.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'detailing.list', component: DetailingList },
      { path: 'edit/:id', name: 'detailing.edit', component: DetailingEdit }
    ]
  },

  {
    path: '/:companyId/work-order',
    component: WO,
    children: [
      { path: '', redirect: { name: 'work-order.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'work-order.list', component: WOList },
      { path: 'scheduling', name: 'work-order.scheduling', component: WOScheduling },
      { path: 'edit/:id', name: 'work-order.edit', component: WOEdit },
      { path: 'auto-wo-edit/:id', name: 'auto-work-order.edit', component: WOAutoEdit }
    ]
  },

  {
    path: '/:companyId/close-work-order',
    component: CWO,
    children: [
      { path: '', redirect: { name: 'close-work-order.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'close-work-order.list', component: CWOList }
    ]
  },

  {
    path: '/:companyId/production-matrix',
    component: PM,
    children: [
      { path: '', redirect: { name: 'production-matrix.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'production-matrix.list', component: PMList }
    ]
  },

  {
    path: '/:companyId/vendor-return',
    component: VendorReturn,
    children: [
      { path: '', redirect: { name: 'vendor-return.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'vendor-return.list', component: VendorReturnList },
      { path: 'edit/:id', name: 'vendor-return.edit', component: VendorReturnEdit }
    ]
  },

  {
    path: '/:companyId/rga',
    component: RGA,
    children: [
      { path: '', redirect: { name: 'rga.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'rga.list', component: RGAList },
      { path: 'edit/:id', name: 'rga.edit', component: RGAEdit }
    ]
  },

  {
    path: '/:companyId/customer-owned-rga',
    component: CORGA,
    children: [
      { path: '', redirect: { name: 'customer-owned-rga.list', params: { companyId: store.getters['auth/company'] } } },
      { path: 'list', name: 'customer-owned-rga.list', component: CORGAList },
      { path: 'edit/:id', name: 'customer-owned-rga.edit', component: CORGAEdit }
    ]
  },

  {
    path: '/:companyId/reports',
    component: Reports,
    children: [
      { path: '', redirect: { name: 'reports.pdm-reports', params: { companyId: store.getters['auth/company'] } } },
      { path: 'pdm-reports', name: 'reports.pdm-reports', component: PDMReports },
      { path: 'production-control-reports', name: 'reports.production-control-reports', component: ProductionControlReports },
      { path: 'inventory-reports', name: 'reports.inventory-reports', component: InventoryReports },
      { path: 'csg-reports', name: 'reports.csg-reports', component: CSGReports },
      { path: 'purchasing-reports', name: 'reports.purchasing-reports', component: PurchasingReports },
      { path: 'accounting-reports', name: 'reports.accounting-reports', component: AccountingReports },
      { path: 'miscellaneous-reports', name: 'reports.miscellaneous-reports', component: MiscellaneousReports }
    ]
  },

  {
    path: '*', component: NotFound
  }
]



// WEBPACK FOOTER //
// ./resources/assets/js/router/routes.js